module.exports = __webpack_public_path__ + "img/KinokoTable47.eea8d46d.jpg";